<template>
  <div
    :id="'bookpage_' + pageNumber"
    :class="`content flex-column justify-center bookpage ${visible ? 'current-page' : ''}`"
    :style="{ display: visible ? 'flex' : 'none' }"
    v-html="processedContent"
  >
  </div>
</template>

<script>
import { mapState } from 'vuex'
import global from '@/constants/GlobalConstant'

export default {
  name: 'Pages',
  props: {
    pageNumber: {
      type: [String, Number],
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: {},
    },
    resource: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      processedContent: ''
    };
  },
  computed: {
    ...mapState({
      bookHighlightData: (state) => state.bookReading.bookHighlightData,
    }),
  },
  watch: {
    content: {
      immediate: true,
      handler(newContent) {
        this.processContent(newContent);
      }
    },
    bookHighlightData: {
      immediate: true,
      handler() {
        if (!this.content) return
        this.processContent(this.content);
      },
    },
  },
  methods: {
    addHightlights(htmlPage) {
      this.bookHighlightData.forEach((item) => {
        if (Number(item.page) === Number(this.pageNumber)) {
          const itemContents = item.serialized.split('\n').filter(text => text)
          this.$highlight.createOnElementClass(
            item.id,
            itemContents,
            htmlPage,
            this.$highlight.setHighlighType(item.ordinalHighlightType),
          )
        }
    })
    },
      processContent(htmlContent) {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlContent;
      this.addHightlights(tempDiv);

      const textNodes = this.getTextNodes(tempDiv);
      let wordIndex = 0;

      textNodes.forEach(node => {
        const words = node.textContent.split(/\s+/);
        const fragment = document.createDocumentFragment();

        words.forEach((word, index) => {
          if (word.replace(/[\W_]+/g, '').trim() !== '') {
            const span = document.createElement('span');
            if (index === (words.length - 1)) {
              span.textContent = word;
            } else {
              span.textContent = word + ' ';
            }
            span.id = `w_${wordIndex}_p${this.pageNumber}`;
            wordIndex++;
            fragment.appendChild(span);
          } else if (word.trim() !== '') {
            fragment.appendChild(document.createTextNode(`${word} `));
          } else {
            fragment.appendChild(document.createTextNode(' '));
          }
        });

        node.parentNode.replaceChild(fragment, node);
      });

        this.processedContent = tempDiv.innerHTML;

      setTimeout(() => {
          document.querySelectorAll('.ilustration img').forEach((element, index) => {
          element.setAttribute(
              'src',
              `${global.BASE_URL_BOOK}${this.resource}/img/${index + 1}_L.jpg`
          )
          })
      }, 100)
    },
    getTextNodes(element) {
      let textNodes = [];
      function recurse(node) {
        if (node.nodeType === Node.TEXT_NODE) {
          textNodes.push(node);
        } else {
          node.childNodes.forEach(child => recurse(child));
        }
      }
      recurse(element);
      return textNodes;
    }
  }
};
</script>
